import { IApiMutationFunction, mapRelationalValue, RelationalValue } from "../../utils";
import { CertificationIssuerEnvironment, ICertificationIssuerResource } from "../types";
import { createCertificationIssuerMutationHook } from "./createCertificationIssuerMutationHook";

export type ICertificationIssuerUpdateMutationParameters = {
    certificationIssuer: RelationalValue<ICertificationIssuerResource>;
    apiKey?: string;
    environment?: CertificationIssuerEnvironment;
    name?: string;
    url?: string;
};
export type ICertificationIssuerUpdateMutationResult = ICertificationIssuerResource;

export const certificationIssuerUpdateMutation: IApiMutationFunction<ICertificationIssuerUpdateMutationParameters> = ({
    certificationIssuer,
    ...data
}) => ({
    method: "PATCH",
    url: `/certification_issuers/${mapRelationalValue(certificationIssuer)}`,
    data,
    headers: { "Content-Type": "application/merge-patch+json" },
});

export const useCertificationIssuerUpdateMutation = createCertificationIssuerMutationHook<
    ICertificationIssuerUpdateMutationParameters,
    ICertificationIssuerUpdateMutationResult
>(certificationIssuerUpdateMutation);
